export const translations = {
  en: {
    // Navigation
    'features': 'Features',
    'how-it-works': 'How it Works',
    'faq': 'FAQ',
    'get-started': 'Get Started',
    'dashboard': 'Dashboard',
    'programs': 'Programs',
    'workouts': 'Workouts',
    'athletes': 'Athletes',
    'notes': 'Notes',
    
    // Auth
    'sign-in': 'Sign In',
    'sign-up': 'Sign Up',
    'email': 'Email',
    'password': 'Password',
    'confirm-password': 'Confirm Password',
    'remember-me': 'Remember me',
    'forgot-password': 'Forgot password?',
    'signing-in': 'Signing in...',
    'or-continue-with': 'or continue with',
    'continue-with-google': 'Continue with Google',
    'dont-have-account': "Don't have an account?",
    'welcome-back': 'Welcome Back',
    'sign-in-to-access': 'Sign in to access your account',
    'sign-in-as-coach': 'Sign in as a coach to access your dashboard',
    'sign-in-as-athlete': 'Sign in as an athlete to access your training',
    'back-to-home': 'Back to home',
    'create-account': 'Create Account',
    'creating-account': 'Creating Account...',
    'join-community': 'Join our community of athletes and coaches',
    'already-have-account': 'Already have an account?',
    'back-to-role-selection': 'Back to role selection',
    'registration-successful': 'Registration Successful!',
    'check-email-verification': 'Please check your email to verify your account.',
    'go-to-login': 'Go to Login',
    'choose-role-to-continue': 'Choose your role to continue with sign in or registration',

    // Profile completion
    'complete-your-profile': 'Complete Your Profile',
    'athlete-profile-setup': 'We need some basic information to set up your athlete profile.',
    'coach-profile-setup': 'We need some basic information to set up your coach profile.',
    'full-name': 'Full Name',
    'full-name-required': 'Full name is required',
    'full-name-placeholder': 'Enter your full name',
    'full-name-placeholder-coach': 'Enter your full name or gym name',
    'full-name-validation-min': 'Name must be at least 2 characters',
    'full-name-validation-max': 'Name must be less than 100 characters',
    'full-name-validation-format': 'Name can only contain letters, spaces, hyphens, and apostrophes',
    'birth-date': 'Birth Date',
    'birth-date-optional': '(optional)',
    'birth-date-required-athletes': 'Required for athlete profiles to ensure age-appropriate training programs',
    'birth-date-validation': 'Please enter a valid birth date (must be at least 13 years old)',
    'birth-date-required-for-athletes': 'Birth date is required for athletes',
    'complete-profile': 'Complete Profile',
    'completing-profile': 'Completing Profile...',
    'profile-completion-help': 'This information helps us provide a better experience tailored to your needs.',
    'incomplete-profile': 'Complete Profile',
    'profile-completion-success': 'Profile completed successfully!',
    'profile-completion-error': 'Failed to complete profile. Please try again.',

    // Registration steps
    'select-your-role': 'Select your role to get started',
    'coach-role': 'Coach',
    'coach-role-description': 'Create and manage training programs for your athletes',
    'athlete-role': 'Athlete',
    'athlete-role-description': 'Access training programs and track your progress',
    'enter-invite-code': 'Enter Invitation Code',
    'invite-code-description': 'Enter the invitation code provided by your coach',
    'invite-code-placeholder': 'Enter your invitation code',
    'verify-code': 'Verify Code',
    'verifying': 'Verifying...',
    'join-as-coach': 'Join as a coach to create and manage training programs',
    'join-as-athlete': 'Join as an athlete to access your training programs',

    // Login page features
    'train-smarter': 'Train Smarter with RUDO',
    'feature-programming-title': 'Intelligent Programming',
    'feature-programming-description': 'Create and customize training plans with our intuitive drag-and-drop interface',
    'feature-communication-title': 'Seamless Communication',
    'feature-communication-description': 'Stay connected with your coach or athletes through integrated messaging',
    'feature-tracking-title': 'Performance Tracking',
    'feature-tracking-description': 'Monitor progress with detailed analytics and visual performance metrics',
    'feature-community-title': 'Supportive Community',
    'feature-community-description': 'Connect with like-minded athletes and coaches to share experiences',

    // Dashboard & Greetings
    'good-morning': 'Good morning',
    'good-afternoon': 'Good afternoon',
    'good-evening': 'Good evening',
    'welcome-dashboard': 'Welcome to your dashboard. Here\'s what\'s happening with your athletes.',
    'welcome-athlete-dashboard': 'Welcome to your training dashboard.',
    'active-athletes': 'Active Athletes',
    'total-athletes': 'Total Athletes',
    'recent-activity': 'Recent Activity',
    'loading-recent-activity': 'Loading recent activity...',
    'no-recent-activity': 'No recent activity',
    'no-recent-activity-desc': 'Once your athletes start completing workouts and adding notes, their activity will appear here.',
    'view-all-athletes': 'View all athletes',
    'completed': 'Completed',
    'updated': 'Updated',
    'as-prescribed': 'Done',
    'scaled': 'Scaled',
    'workout': 'Workout',
    'across-teams': 'across {count} teams',
    'assigned': 'assigned',
    'weeks': 'weeks',
    'mark-workout-completed': 'Mark Workout as Completed',
    'completion-question': 'Did you complete this workout as prescribed or did you scale it?',
    'cancel': 'Cancel',

    // Athlete Dashboard
    'your-training': 'Your Training',
    'no-workouts-today': 'No workouts scheduled for today',
    'no-workouts-scheduled': 'No workouts scheduled',
    'check-other-days': 'Check other days for your training schedule',
    'assigned-programs': 'Assigned Programs',
    'no-programs-assigned': 'You don\'t have any programs assigned yet.',
    'show-less': 'Show less',
    'show-more-programs': 'Show {count} more programs',
    'coach-label': 'Coach',
    'loading-programs': 'Loading your programs...',
    'inactive-account': 'Account Inactive',
    'inactive-account-desc': 'Your athlete account is currently inactive. You will not see any workouts or programs assigned until your coach reactivates your account.',
    'what-this-means': 'What this means:',
    'no-workouts-displayed': 'No workouts will be displayed',
    'no-programs-visible': 'No training programs will be visible',
    'calendar-empty': 'Your calendar will remain empty',
    'to-reactivate': 'To reactivate your account:',
    'contact-coach': 'Please reach out to your coach',
    'contact-coaches': 'Please reach out to your coaches',
    'request-reactivation': 'to request account reactivation.',
    'contact-coach-directly': 'Contact your coach directly or through your usual communication channel.',

    // PWA Install Banner
    'pwa-add-to-home': '⚡ Add RUDO to your home screen',
    'pwa-install-app': '🚀 Install RUDO App',
    'pwa-install-desktop': '💪 Install RUDO',
    'pwa-install-generic': '⭐ Get the RUDO App',
    'pwa-ios-description': 'Install RUDO: Tap the [SHARE_ICON] Share button → "Add to Home Screen"',
    'pwa-android-description': 'Get faster access to your workouts. Install the RUDO app.',
    'pwa-desktop-description': 'Get desktop app with better performance and offline capability.',
    'pwa-generic-description': 'Install RUDO for faster access to your workouts.',
    'pwa-show-me-how': 'Show me how',
    'pwa-install-now': 'Install now',
    'pwa-install-app-btn': 'Install app',
    'pwa-install-btn': 'Install',
    'pwa-maybe-later': 'Maybe later',
    'pwa-faster-loading': 'Faster loading',
    'pwa-offline-access': 'Offline access',
    'pwa-native-feel': 'Native app feel',
    'pwa-instant-loading': 'Instant loading',
    'pwa-works-offline': 'Works offline',
    'pwa-home-screen-access': 'Home screen access',
    'pwa-desktop-notifications': 'Desktop notifications',
    'pwa-faster-access': 'Faster access',
    'pwa-better-performance': 'Better performance',
    'pwa-quick-launch': 'Quick launch',
    'pwa-benefits': 'Benefits',

    // Footer
    'product': 'Product',
    'legal': 'Legal',
    'contact': 'Contact',
    'privacy-policy': 'Privacy Policy',
    'terms-of-service': 'Terms of Service',
    'built-in': 'Built in 🇦🇷 Powered by the RUDO team',
    'new-slogan-line1': 'Coach Smarter.',
    'new-slogan-line2': 'Manage Less.',
    'new-slogan-line3': '',

    // Landing
    'hero-title': 'Coach Smarter,',
    'hero-subtitle': 'Manage Less',
    'hero-description': 'RUDO gives CrossFit coaches everything they need to program, track, and grow — without wasting hours managing chaos.',
    'request-access': 'Request Access to the Beta',
    'trusted-by': 'Already trusted by coaches programming for 300+ athletes',
    'programming-simplified': 'Programming, Simplified.',
    'platform-preview': 'See how fast you can build and assign a training week inside RUDO.',
    'coaches-feedback': 'Built with feedback from coaches across 30+ top-tier gyms',
    'coaches-trust': 'Trusted by coaches designing high-performance programs for hundreds of athletes',
    'why-switch': 'Why Coaches Are Switching to RUDO',
    'chaos-control': 'Say goodbye to chaos. Say hello to control.',
    'both-sides': 'Built for Both Sides of the Barbell',
    'still-questions': 'Still Have Questions?',
    'ready-to-pro': 'Ready to program like a pro?',
    'shape-future': 'Join the coaches shaping the future of CrossFit training',

    // Testimonials
    'testimonial-1-quote': 'RUDO replaced Google Sheets and saved me 6 hours a week.',
    'testimonial-1-name': 'Carlos Rodriguez',
    'testimonial-1-role': 'Head Coach, CrossFit Madrid',
    'testimonial-2-quote': 'Finally, software that understands how CrossFit coaches actually work.',
    'testimonial-2-name': 'Sarah Thompson',
    'testimonial-2-role': 'Owner, CrossFit Elite',
    'testimonial-3-quote': 'The athlete feedback loop is a game-changer for remote coaching.',
    'testimonial-3-name': 'Juan Martinez',
    'testimonial-3-role': 'Programming Director, CrossFit Buenos Aires',

    // FAQ
    'faq-1-question': 'Can I use RUDO for both group and 1-on-1 clients?',
    'faq-1-answer': 'Yes — assign programs to individuals, small groups, or your entire roster in one click.',
    'faq-2-question': 'Do my athletes need to download anything?',
    'faq-2-answer': 'Nope. They get instant access through a mobile-friendly web app — no installs, no friction.',
    'faq-3-question': 'What makes RUDO different from other coaching platforms?',
    'faq-3-answer': 'RUDO is purpose-built for CrossFit and HYROX coaches — not generic trainers. Every feature is designed around real-world programming, feedback, and athlete flow in high-performance functional training environments.',
    'faq-4-question': 'Can I customize my own programming blocks?',
    'faq-4-answer': 'Yes. Build, reuse, and edit your own templates — warm-ups, EMOMs, skills — and deploy them in seconds.',
    'faq-5-question': "What's included in the beta?",
    'faq-5-answer': 'Full access to all core features, direct access to the founding team, and lifetime perks for helping us shape the future of RUDO.',

    // Comparison Section
    'spreadsheet-problem': 'Dozens of tabs. No structure.',
    'spreadsheet-solution': 'Drag-and-drop full weeks in minutes.',
    'spreadsheet-problem-subtext': "Where the hell is Tuesday's WOD?",
    'spreadsheet-solution-subtext': 'One clean calendar. Total control.',
    
    'copy-paste-problem': 'Copy-paste for every athlete.',
    'copy-paste-solution': 'Assign to groups in one click.',
    'copy-paste-problem-subtext': 'Manual updates = wasted time',
    'copy-paste-solution-subtext': 'Bulk actions, instant updates',
    
    'feedback-problem': 'Feedback lost in DMs.',
    'feedback-solution': 'Comments tracked & organized.',
    'feedback-problem-subtext': 'Scattered across apps & chats',
    'feedback-solution-subtext': 'All feedback in one place',
    
    'branding-problem': 'Looks amateur.',
    'branding-solution': 'Sleek branded platform.',
    'branding-problem-subtext': 'Generic spreadsheets & docs',
    'branding-solution-subtext': 'Professional, custom experience',

    // Coach Features
    'coach-features-title': 'For Coaches',
    'save-time': 'Save hours on programming and admin',
    'manage-groups': 'Manage multiple groups efficiently',
    'look-pro': 'Look professional with branded apps',

    // Athlete Features
    'athlete-features-title': 'For Athletes',
    'access-workouts': 'Access workouts anywhere, anytime',
    'instant-feedback': 'Give and receive feedback instantly',
    'track-progress': 'Track progress with detailed analytics',

    // Common Terms
    'search-athletes-programs': 'Search athletes, programs...',
    'search-programs': 'Search programs...',

    // Navigation & Actions
    'back-to-programs': 'Back to Programs',
    'back-to-athletes': 'Back to Athletes',
    'add-workout': 'Add Workout',
    'assign-workout': 'Assign Workout',
    'create-new-workout': 'Create New Workout',
    'edit-workout': 'Edit Workout',
    'delete-workout': 'Delete Workout',
    'save': 'Save',
    'saving': 'Saving...',
    'delete': 'Delete',
    'today': 'Today',
    'week': 'Week',
    'day': 'Day',
    'month': 'Month',
    'week-view': 'Week View',
    'month-view': 'Month View',
    'day-view': 'Day View',
    'select': 'Select',
    'close': 'Close',
    'search': 'Search',
    'filter': 'Filter',
    'all': 'All',
    'create': 'Create',
    'edit': 'Edit',
    'update': 'Update',
    'remove': 'Remove',

    // Calendar & Date
    'mon': 'Mon',
    'tue': 'Tue', 
    'wed': 'Wed',
    'thu': 'Thu',
    'fri': 'Fri',
    'sat': 'Sat',
    'sun': 'Sun',
    'monday': 'Monday',
    'tuesday': 'Tuesday',
    'wednesday': 'Wednesday', 
    'thursday': 'Thursday',
    'friday': 'Friday',
    'saturday': 'Saturday',
    'sunday': 'Sunday',
    'january': 'January',
    'february': 'February',
    'march': 'March',
    'april': 'April',
    'may': 'May',
    'june': 'June',
    'july': 'July',
    'august': 'August',
    'september': 'September',
    'october': 'October',
    'november': 'November',
    'december': 'December',

    // Program Calendar
    'select-workout-for': 'Seleccionar Workout para',
    'search-workouts': 'Buscar workouts...',
    'no-matching-workouts': 'No se encontraron workouts coincidentes.',
    'no-workouts-available': 'No hay workouts disponibles.',
    'select-workout': 'Seleccionar Workout',
    'unsaved-changes': 'Cambios No Guardados',
    'unsaved-changes-desc': 'Tienes cambios no guardados. ¿Quieres guardar tus cambios antes de salir?',
    'dont-save': 'No Guardar',
    'save-changes': 'Guardar Cambios',
    'are-you-sure-delete': '¿Estás seguro de que quieres eliminar este workout? Esta acción no se puede deshacer.',
    'changes-saved-successfully': '¡Cambios guardados exitosamente!',
    'error-saving-changes': 'Error al guardar cambios. Por favor, inténtalo de nuevo.',
    'changes-discarded': 'Cambios descartados',

    // Athlete Calendar
    'view-manage-workouts': 'Ver y gestionar asignaciones de workouts para este atleta',
    'loading-workouts': 'Cargando workouts...',
    'assign-workout-for': 'Asignar Workout para',
    'selected-date': 'Fecha Seleccionada',
    'workout-library': 'Biblioteca de Workouts',
    'no-matching-workouts-found': 'No se encontraron workouts coincidentes.',
    'no-workouts-in-library': 'Aún no tienes workouts en tu biblioteca.',
    'create-a-new-workout': 'Crear un nuevo workout',
    'opens-workout-form': 'Abre el formulario de workout para crear un workout personalizado',
    'move-workout': 'Mover Workout',
    'move-workout-confirmation': '¿Estás seguro de que quieres mover este workout de {sourceDate} a {destinationDate}?',
    'move-workout-button': 'Mover Workout',
    'workout-moved-success': 'Workout movido de {sourceDate} a {destinationDate}',
    'move-workout-failed': 'No se pudo mover el workout. Por favor, inténtalo de nuevo.',
    'workout-created-successfully': '¡Workout creado exitosamente!',
    'failed-create-workout': 'Error al crear workout. Por favor, inténtalo de nuevo.',
    'failed-assign-workout': 'Error al asignar workout. Por favor, inténtalo de nuevo.',

    // Workouts Page
    'create-manage-workouts': 'Crear y gestionar tu biblioteca de workouts',
    'search-your-workouts': 'Buscar en tus workouts...',
    'filter-by-type': 'Filtrar por tipo',
    'no-workouts-yet': 'Aún no hay workouts',
    'start-building-library': 'Comienza a construir tu biblioteca de workouts creando tu primer workout.',
    'get-started-workouts': 'Comenzar',
    'no-workouts-match-search': 'Ningún workout coincide con tus criterios de búsqueda.',
    'try-different-search': 'Prueba con un término de búsqueda o filtro diferente.',
    'error-creating-workout': 'Hubo un error al crear el workout. Por favor, inténtalo de nuevo.',
    'error-updating-workout': 'Hubo un error al actualizar el workout. Por favor, inténtalo de nuevo.',
    'error-deleting-workout': 'Hubo un error al eliminar el workout. Por favor, inténtalo de nuevo.',
    'confirm-delete-workout': '¿Estás seguro de que quieres eliminar este workout? Esta acción no se puede deshacer.',

    // General Messages
    'loading': 'Loading...',
    'error': 'Error',
    'success': 'Success',
    'warning': 'Warning',
    'info': 'Info',
    
    // Program Card & UI Elements
    'view-details': 'View Details',
    'assign': 'Assign',
    'edit-program': 'Edit Program',
    'delete-program': 'Delete Program',
    'manage-assignments': 'Manage Assignments',
    'publish-program': 'Publish Program',
    'archive-program': 'Archive Program',
    'revert-to-draft': 'Revert to Draft',
    'view-program': 'View Program',
    'draft': 'Draft',
    'published': 'Published',
    'archived': 'Archived',
    
    // Program Calendar specific
    'design-new-workout-from-scratch': 'Design a new workout from scratch',
    'or': 'or',
    'search-existing-workouts': 'Search Existing Workouts',
    'choose-from-workout-library': 'Choose from your workout library',
    'no-workouts-for-this-day': 'No workouts for this day yet.',
    'outside-program-date-range': 'This date is outside the program date range.',

    // Additional Workout Card Labels
    'mark-complete': 'Mark Complete',
    'mark-as-completed': 'Mark as Completed',
    'add-notes': 'Add Notes',
    'edit-notes': 'Edit Notes',
    'program': 'Program',
    'assigned-program': 'Assigned Program',
    'completed-on': 'Completed on',
    'completed-at': 'Completed {date} at {time}',
    'workout-notes-placeholder': 'Add your workout notes, results, or modifications...',
    'mark-as-incomplete': 'Mark as Incomplete?',
    'mark-incomplete-question': 'Are you sure you want to mark this workout as incomplete? This will remove the completion status and timestamp.',
    'yes-mark-incomplete': 'Yes, Mark Incomplete',

    // Coach Subscription Status Banner
    'subscription-pending-title': 'Account Pending Approval',
    'subscription-pending-message': 'Your coach registration is currently pending approval. You will have limited access until your account is activated.',
    'subscription-pending-info': 'We\'re reviewing your application and will notify you once approved. This typically takes 1-2 business days.',
    'subscription-suspended-title': 'Account Suspended',
    'subscription-suspended-message': 'Your account has been suspended. Please contact support for assistance.',
    'subscription-cancelled-title': 'Subscription Cancelled',
    'subscription-cancelled-message': 'Your subscription has been cancelled. Contact support to reactivate your account.',
    'subscription-unknown-title': 'Account Status Unknown',
    'subscription-unknown-message': 'Unable to determine account status. Please contact support.',
    'contact-support': 'Contact Support',
    'limited-access-mode': 'Limited Access Mode',
    'limited-access-description': 'Your account is currently pending approval. Once approved, you\'ll have access to all coach features including:',
    'limited-access-features-1': 'Create and manage athletes',
    'limited-access-features-2': 'Design custom workout programs',
    'limited-access-features-3': 'Track athlete progress and activity',
    'limited-access-features-4': 'Send athlete invitations',
    'limited-access-features-5': 'Advanced analytics and reporting',
    'limited-access-review-time': 'We typically review applications within 1-2 business days.',
    'access-restricted': 'Access Restricted',
    'access-restricted-suspended': 'Your account has been suspended. Please contact support to resolve this issue.',
    'access-restricted-cancelled': 'Your subscription has been cancelled. Contact support to reactivate your account.',
    'access-restricted-default': 'Access to dashboard features is currently restricted. Please contact support for assistance.'
  },
  es: {
    // Navigation
    'features': 'Características',
    'how-it-works': 'Cómo Funciona',
    'faq': 'Preguntas Frecuentes',
    'get-started': 'Comenzar',
    'dashboard': 'Panel',
    'programs': 'Programas',
    'workouts': 'Workouts',
    'athletes': 'Atletas',
    'notes': 'Notas',
    
    // Auth
    'sign-in': 'Iniciar Sesión',
    'sign-up': 'Registrarse',
    'email': 'Email',
    'password': 'Contraseña',
    'confirm-password': 'Confirmar Contraseña',
    'remember-me': 'Recordarme',
    'forgot-password': '¿Olvidaste tu contraseña?',
    'signing-in': 'Iniciando sesión...',
    'or-continue-with': 'o continuar con',
    'continue-with-google': 'Continuar con Google',
    'dont-have-account': '¿No tienes una cuenta?',
    'welcome-back': 'Bienvenido de nuevo',
    'sign-in-to-access': 'Inicia sesión para acceder a tu cuenta',
    'sign-in-as-coach': 'Inicia sesión como entrenador para acceder a tu panel',
    'sign-in-as-athlete': 'Inicia sesión como atleta para acceder a tu entrenamiento',
    'back-to-home': 'Volver al inicio',
    'create-account': 'Crear Cuenta',
    'creating-account': 'Creando Cuenta...',
    'join-community': 'Únete a nuestra comunidad de atletas y entrenadores',
    'already-have-account': '¿Ya tienes una cuenta?',
    'back-to-role-selection': 'Volver a selección de rol',
    'registration-successful': '¡Registro Exitoso!',
    'check-email-verification': 'Por favor, revisa tu correo electrónico para verificar tu cuenta.',
    'go-to-login': 'Ir a Iniciar Sesión',
    'choose-role-to-continue': 'Elige tu rol para continuar con el inicio de sesión o registro',

    // Profile completion
    'complete-your-profile': 'Completa tu Perfil',
    'athlete-profile-setup': 'Necesitamos información básica para configurar tu perfil de atleta.',
    'coach-profile-setup': 'Necesitamos información básica para configurar tu perfil de entrenador o gimnasio.',
    'full-name': 'Nombre Completo',
    'full-name-required': 'El nombre completo es requerido',
    'full-name-placeholder': 'Ingresa tu nombre completo',
    'full-name-placeholder-coach': 'Ingresa tu nombre completo o nombre del gimnasio',
    'full-name-validation-min': 'El nombre debe tener al menos 2 caracteres',
    'full-name-validation-max': 'El nombre debe tener menos de 100 caracteres',
    'full-name-validation-format': 'El nombre solo puede contener letras, espacios, guiones y apostrofes',
    'birth-date': 'Fecha de Nacimiento',
    'birth-date-optional': '(opcional)',
    'birth-date-required-athletes': 'Requerido para perfiles de atleta para asegurar programas de entrenamiento apropiados para la edad',
    'birth-date-validation': 'Por favor ingresa una fecha de nacimiento válida (debe tener al menos 13 años)',
    'birth-date-required-for-athletes': 'La fecha de nacimiento es requerida para atletas',
    'complete-profile': 'Completar Perfil',
    'completing-profile': 'Completando Perfil...',
    'profile-completion-help': 'Esta información nos ayuda a brindar una mejor experiencia adaptada a tus necesidades.',
    'incomplete-profile': 'Completar Perfil',
    'profile-completion-success': 'Perfil completado exitosamente!',
    'profile-completion-error': 'No se pudo completar el perfil. Por favor, inténtelo de nuevo.',

    // Registration steps
    'select-your-role': 'Selecciona tu rol para comenzar',
    'coach-role': 'Entrenador',
    'coach-role-description': 'Crea y gestiona programas de entrenamiento para tus atletas',
    'athlete-role': 'Atleta',
    'athlete-role-description': 'Accede a programas de entrenamiento y sigue tu progreso',
    'enter-invite-code': 'Ingresa el Código de Invitación',
    'invite-code-description': 'Ingresa el código de invitación proporcionado por tu entrenador',
    'invite-code-placeholder': 'Ingresa tu código de invitación',
    'verify-code': 'Verificar Código',
    'verifying': 'Verificando...',
    'join-as-coach': 'Únete como entrenador para crear y gestionar programas de entrenamiento',
    'join-as-athlete': 'Únete como atleta para acceder a tus programas de entrenamiento',

    // Login page features
    'train-smarter': 'Entrena más inteligentemente con RUDO',
    'feature-programming-title': 'Programación Inteligente',
    'feature-programming-description': 'Crea y personaliza planes de entrenamiento con nuestra intuitiva interfaz de arrastrar y soltar',
    'feature-communication-title': 'Comunicación Fluida',
    'feature-communication-description': 'Mantente conectado con tu entrenador o atletas a través de mensajería integrada',
    'feature-tracking-title': 'Seguimiento de Rendimiento',
    'feature-tracking-description': 'Monitorea el progreso con análisis detallados y métricas visuales de rendimiento',
    'feature-community-title': 'Comunidad de Apoyo',
    'feature-community-description': 'Conéctate con atletas y entrenadores afines para compartir experiencias',

    // Dashboard & Greetings
    'good-morning': 'Buenos días',
    'good-afternoon': 'Buenas tardes',
    'good-evening': 'Buenas noches',
    'welcome-dashboard': 'Bienvenido a tu panel. Esto es lo que está pasando con tus atletas.',
    'welcome-athlete-dashboard': 'Bienvenido a tu panel de entrenamiento.',
    'active-athletes': 'Atletas Activos',
    'total-athletes': 'Total de Atletas',
    'recent-activity': 'Actividad Reciente',
    'loading-recent-activity': 'Cargando actividad reciente...',
    'no-recent-activity': 'Sin actividad reciente',
    'no-recent-activity-desc': 'Una vez que tus atletas comiencen a completar entrenamientos y agregar notas, su actividad aparecerá aquí.',
    'view-all-athletes': 'Ver todos los atletas',
    'completed': 'Completado',
    'updated': 'Actualizado',
    'as-prescribed': 'Completado',
    'scaled': 'Escalado',
    'workout': 'Workout',
    'across-teams': 'en {count} equipos',
    'assigned': 'asignados',
    'weeks': 'semanas',
    'mark-workout-completed': 'Marcar Workout como Completado',
    'completion-question': '¿Completaste este workout como se te indicó o lo escalaste?',
    'cancel': 'Cancelar',

    // Athlete Dashboard
    'your-training': 'Tu Entrenamiento',
    'no-workouts-today': 'No hay workouts programados para hoy',
    'no-workouts-scheduled': 'No hay workouts programados',
    'check-other-days': 'Revisa otros días para tu horario de entrenamiento',
    'assigned-programs': 'Programas Asignados',
    'no-programs-assigned': 'Aún no tienes programas asignados.',
    'show-less': 'Mostrar menos',
    'show-more-programs': 'Mostrar {count} programas más',
    'coach-label': 'Entrenador',
    'loading-programs': 'Cargando tus programas...',
    'inactive-account': 'Cuenta Inactiva',
    'inactive-account-desc': 'Tu cuenta de atleta está actualmente inactiva. No verás ningún workout o programa asignado hasta que tu entrenador reactive tu cuenta.',
    'what-this-means': 'Lo que esto significa:',
    'no-workouts-displayed': 'No se mostrarán workouts',
    'no-programs-visible': 'No se verán programas de entrenamiento',
    'calendar-empty': 'Tu calendario permanecerá vacío',
    'to-reactivate': 'Para reactivar tu cuenta:',
    'contact-coach': 'Por favor contacta a tu entrenador',
    'contact-coaches': 'Por favor contacta a tus entrenadores',
    'request-reactivation': 'para solicitar la reactivación de la cuenta.',
    'contact-coach-directly': 'Contacta a tu entrenador directamente o a través de tu canal de comunicación habitual.',

    // PWA Install Banner
    'pwa-add-to-home': '⚡ Agrega RUDO a tu pantalla de inicio',
    'pwa-install-app': '🚀 Instalar App RUDO',
    'pwa-install-desktop': '💪 Instalar RUDO',
    'pwa-install-generic': '⭐ Obtener la App RUDO',
    'pwa-ios-description': 'Instalar RUDO: Toca el botón [SHARE_ICON] Compartir → "Agregar a pantalla de inicio"',
    'pwa-android-description': 'Accede más rápido a tus entrenamientos. Instala la app RUDO.',
    'pwa-desktop-description': 'Obtén la app de escritorio con mejor rendimiento y capacidad sin conexión.',
    'pwa-generic-description': 'Instala RUDO para acceder más rápido a tus entrenamientos.',
    'pwa-show-me-how': 'Show me how',
    'pwa-install-now': 'Install now',
    'pwa-install-app-btn': 'Install app',
    'pwa-install-btn': 'Install',
    'pwa-maybe-later': 'Maybe later',
    'pwa-faster-loading': 'Faster loading',
    'pwa-offline-access': 'Offline access',
    'pwa-native-feel': 'Native app feel',
    'pwa-instant-loading': 'Instant loading',
    'pwa-works-offline': 'Works offline',
    'pwa-home-screen-access': 'Home screen access',
    'pwa-desktop-notifications': 'Desktop notifications',
    'pwa-faster-access': 'Faster access',
    'pwa-better-performance': 'Better performance',
    'pwa-quick-launch': 'Quick launch',
    'pwa-benefits': 'Benefits',

    // Footer
    'product': 'Producto',
    'legal': 'Legal',
    'contact': 'Contacto',
    'privacy-policy': 'Política de Privacidad',
    'terms-of-service': 'Términos de Servicio',
    'built-in': 'Hecho en 🇦🇷 Impulsado por el equipo RUDO',
    'new-slogan-line1': 'Mas Coaching.',
    'new-slogan-line2': 'Menos gestión.',
    'new-slogan-line3': '',

    // Landing
    'hero-title': 'Mas Coaching,',
    'hero-subtitle': 'Menos gestión',
    'hero-description': 'RUDO brinda a los entrenadores de CrossFit todo lo que necesitan para programar, hacer seguimiento y crecer, sin perder horas gestionando el caos.',
    'request-access': 'Solicitar Acceso a la Beta',
    'trusted-by': 'Ya confían en nosotros entrenadores que programan para más de 300 atletas',
    'programming-simplified': 'Programación, Simplificada.',
    'platform-preview': 'Mira qué tan rápido puedes crear y asignar una semana de entrenamiento en RUDO.',
    'coaches-feedback': 'Construido con feedback de entrenadores de más de 30 boxes de primer nivel',
    'coaches-trust': 'De confianza para entrenadores que diseñan programas de alto rendimiento para cientos de atletas',
    'why-switch': '¿Por qué los Entrenadores están Cambiando a RUDO?',
    'chaos-control': 'Di adiós al caos. Da la bienvenida al control.',
    'both-sides': 'Construido para Ambos Lados de la Barra',
    'still-questions': '¿Aún tienes preguntas?',
    'ready-to-pro': '¿Listo para programar como un pro?',
    'shape-future': 'Únete a los entrenadores que están dando forma al futuro del entrenamiento CrossFit',

    // Testimonials
    'testimonial-1-quote': 'RUDO reemplazó Google Sheets y me ahorró 6 horas por semana.',
    'testimonial-1-name': 'Carlos Rodriguez',
    'testimonial-1-role': 'Head Coach, CrossFit Madrid',
    'testimonial-2-quote': 'Por fin, un software que entiende cómo trabajan realmente los coaches de CrossFit.',
    'testimonial-2-name': 'Sarah Thompson',
    'testimonial-2-role': 'Dueña, CrossFit Elite',
    'testimonial-3-quote': 'El feedback loop con los atletas es un game-changer para el coaching remoto.',
    'testimonial-3-name': 'Juan Martinez',
    'testimonial-3-role': 'Director de Programación, CrossFit Buenos Aires',

    // FAQ
    'faq-1-question': '¿Puedo usar RUDO tanto para grupos como para clientes 1-a-1?',
    'faq-1-answer': 'Sí — asigna programas a individuos, grupos pequeños o todo tu roster con un solo clic.',
    'faq-2-question': '¿Mis atletas necesitan descargar algo?',
    'faq-2-answer': 'No. Obtienen acceso instantáneo a través de una web app optimizada para móviles — sin instalaciones, sin fricción.',
    'faq-3-question': '¿Qué hace diferente a RUDO de otras plataformas de coaching?',
    'faq-3-answer': 'RUDO está construido específicamente para coaches de CrossFit y HYROX — no para entrenadores genéricos. Cada característica está diseñada alrededor de la programación del mundo real, feedback y flujo de atletas en entornos de entrenamiento funcional de alto rendimiento.',
    'faq-4-question': '¿Puedo personalizar mis propios bloques de programación?',
    'faq-4-answer': 'Sí. Construye, reutiliza y edita tus propias plantillas — calentamientos, EMOMs, habilidades — y despliégalos en segundos.',
    'faq-5-question': '¿Qué incluye la beta?',
    'faq-5-answer': 'Acceso completo a todas las funciones principales, acceso directo al equipo fundador y beneficios de por vida por ayudarnos a dar forma al futuro de RUDO.',

    // Comparison Section
    'spreadsheet-problem': 'Docenas de pestañas. Sin estructura.',
    'spreadsheet-solution': 'Arrastra y suelta semanas completas en minutos.',
    'spreadsheet-problem-subtext': '¿Dónde está el WOD del martes?',
    'spreadsheet-solution-subtext': 'Un calendario limpio. Control total.',
    
    'copy-paste-problem': 'Copiar y pegar para cada atleta.',
    'copy-paste-solution': 'Asigna a grupos con un clic.',
    'copy-paste-problem-subtext': 'Actualizaciones manuales = tiempo perdido',
    'copy-paste-solution-subtext': 'Acciones en masa, actualizaciones instantáneas',
    
    'feedback-problem': 'Feedback perdido en DMs.',
    'feedback-solution': 'Comentarios organizados y rastreados.',
    'feedback-problem-subtext': 'Disperso en apps y chats',
    'feedback-solution-subtext': 'Todo el feedback en un solo lugar',
    
    'branding-problem': 'Parece amateur.',
    'branding-solution': 'Plataforma profesional con tu marca.',
    'branding-problem-subtext': 'Hojas de cálculo y docs genéricos',
    'branding-solution-subtext': 'Experiencia profesional personalizada',

    // Coach Features
    'coach-features-title': 'Para Coaches',
    'save-time': 'Ahorra horas en programación y admin',
    'manage-groups': 'Gestiona múltiples grupos eficientemente',
    'look-pro': 'Luce profesional con apps personalizadas',

    // Athlete Features
    'athlete-features-title': 'Para Atletas',
    'access-workouts': 'Accede a los entrenamientos donde sea, cuando sea',
    'instant-feedback': 'Da y recibe feedback instantáneamente',
    'track-progress': 'Sigue tu progreso con análisis detallados',

    // Common Terms
    'search-athletes-programs': 'Buscar atletas, programas...',
    'search-programs': 'Buscar programas...',

    // Navigation & Actions
    'back-to-programs': 'Volver a Programas',
    'back-to-athletes': 'Volver a Atletas',
    'add-workout': 'Agregar Workout',
    'assign-workout': 'Asignar Workout',
    'create-new-workout': 'Crear Nuevo Workout',
    'edit-workout': 'Editar Workout',
    'delete-workout': 'Eliminar Workout',
    'save': 'Guardar',
    'saving': 'Guardando...',
    'delete': 'Eliminar',
    'today': 'Hoy',
    'week': 'Semana',
    'day': 'Día',
    'month': 'Mes',
    'week-view': 'Vista Semanal',
    'month-view': 'Vista Mensual',
    'day-view': 'Vista Diaria',
    'select': 'Seleccionar',
    'close': 'Cerrar',
    'search': 'Buscar',
    'filter': 'Filtrar',
    'all': 'Todos',
    'create': 'Crear',
    'edit': 'Editar',
    'update': 'Actualizar',
    'remove': 'Remover',

    // Calendar & Date
    'mon': 'Lun',
    'tue': 'Mar', 
    'wed': 'Mié',
    'thu': 'Jue',
    'fri': 'Vie',
    'sat': 'Sáb',
    'sun': 'Dom',
    'monday': 'Lunes',
    'tuesday': 'Martes',
    'wednesday': 'Miércoles', 
    'thursday': 'Jueves',
    'friday': 'Viernes',
    'saturday': 'Sábado',
    'sunday': 'Domingo',
    'january': 'Enero',
    'february': 'Febrero',
    'march': 'Marzo',
    'april': 'Abril',
    'may': 'Mayo',
    'june': 'Junio',
    'july': 'Julio',
    'august': 'Agosto',
    'september': 'Septiembre',
    'october': 'Octubre',
    'november': 'Noviembre',
    'december': 'Diciembre',

    // Program Calendar
    'select-workout-for': 'Seleccionar Workout para',
    'search-workouts': 'Buscar workouts...',
    'no-matching-workouts': 'No se encontraron workouts coincidentes.',
    'no-workouts-available': 'No hay workouts disponibles.',
    'select-workout': 'Seleccionar Workout',
    'unsaved-changes': 'Cambios No Guardados',
    'unsaved-changes-desc': 'Tienes cambios no guardados. ¿Quieres guardar tus cambios antes de salir?',
    'dont-save': 'No Guardar',
    'save-changes': 'Guardar Cambios',
    'are-you-sure-delete': '¿Estás seguro de que quieres eliminar este workout? Esta acción no se puede deshacer.',
    'changes-saved-successfully': '¡Cambios guardados exitosamente!',
    'error-saving-changes': 'Error al guardar cambios. Por favor, inténtalo de nuevo.',
    'changes-discarded': 'Cambios descartados',

    // Athlete Calendar
    'view-manage-workouts': 'Ver y gestionar asignaciones de workouts para este atleta',
    'loading-workouts': 'Cargando workouts...',
    'assign-workout-for': 'Asignar Workout para',
    'selected-date': 'Fecha Seleccionada',
    'workout-library': 'Biblioteca de Workouts',
    'no-matching-workouts-found': 'No se encontraron workouts coincidentes.',
    'no-workouts-in-library': 'Aún no tienes workouts en tu biblioteca.',
    'create-a-new-workout': 'Crear un nuevo workout',
    'opens-workout-form': 'Abre el formulario de workout para crear un workout personalizado',
    'move-workout': 'Mover Workout',
    'move-workout-confirmation': '¿Estás seguro de que quieres mover este workout de {sourceDate} a {destinationDate}?',
    'move-workout-button': 'Mover Workout',
    'workout-moved-success': 'Workout movido de {sourceDate} a {destinationDate}',
    'move-workout-failed': 'No se pudo mover el workout. Por favor, inténtalo de nuevo.',
    'workout-created-successfully': '¡Workout creado exitosamente!',
    'failed-create-workout': 'Error al crear workout. Por favor, inténtalo de nuevo.',
    'failed-assign-workout': 'Error al asignar workout. Por favor, inténtalo de nuevo.',

    // Workouts Page
    'create-manage-workouts': 'Crear y gestionar tu biblioteca de workouts',
    'search-your-workouts': 'Buscar en tus workouts...',
    'filter-by-type': 'Filtrar por tipo',
    'no-workouts-yet': 'Aún no hay workouts',
    'start-building-library': 'Comienza a construir tu biblioteca de workouts creando tu primer workout.',
    'get-started-workouts': 'Comenzar',
    'no-workouts-match-search': 'Ningún workout coincide con tus criterios de búsqueda.',
    'try-different-search': 'Prueba con un término de búsqueda o filtro diferente.',
    'error-creating-workout': 'Hubo un error al crear el workout. Por favor, inténtalo de nuevo.',
    'error-updating-workout': 'Hubo un error al actualizar el workout. Por favor, inténtalo de nuevo.',
    'error-deleting-workout': 'Hubo un error al eliminar el workout. Por favor, inténtalo de nuevo.',
    'confirm-delete-workout': '¿Estás seguro de que quieres eliminar este workout? Esta acción no se puede deshacer.',

    // General Messages
    'loading': 'Cargando...',
    'error': 'Error',
    'success': 'Éxito',
    'warning': 'Advertencia',
    'info': 'Información',
    
    // Program Card & UI Elements
    'view-details': 'Ver Detalles',
    'assign': 'Asignar',
    'edit-program': 'Editar Programa',
    'delete-program': 'Eliminar Programa',
    'manage-assignments': 'Gestionar Asignaciones',
    'publish-program': 'Publicar Programa',
    'archive-program': 'Archivar Programa',
    'revert-to-draft': 'Revertir a Borrador',
    'view-program': 'Ver Programa',
    'draft': 'Borrador',
    'published': 'Publicado',
    'archived': 'Archivado',
    
    // Program Calendar specific
    'design-new-workout-from-scratch': 'Diseñar un nuevo workout desde cero',
    'or': 'o',
    'search-existing-workouts': 'Buscar Workouts Existentes',
    'choose-from-workout-library': 'Elegir de tu biblioteca de workouts',
    'no-workouts-for-this-day': 'Aún no hay workouts para este día.',
    'outside-program-date-range': 'Esta fecha está fuera del rango de fechas del programa.',

    // Additional Workout Card Labels
    'mark-complete': 'Marcar Completo',
    'mark-as-completed': 'Marcar como Completado',
    'add-notes': 'Agregar Notas',
    'edit-notes': 'Editar Notas',
    'program': 'Programa',
    'assigned-program': 'Programa Asignado',
    'completed-on': 'Completado el',
    'completed-at': 'Completado {date} a las {time}',
    'workout-notes-placeholder': 'Agrega tus notas de entrenamiento, resultados o modificaciones...',
    'mark-as-incomplete': '¿Marcar como Incompleto?',
    'mark-incomplete-question': '¿Estás seguro de que quieres marcar este workout como incompleto? Esto eliminará el estado de completado y la marca de tiempo.',
    'yes-mark-incomplete': 'Sí, Marcar Incompleto',

    // Coach Subscription Status Banner
    'subscription-pending-title': 'Cuenta Pendiente de Aprobación',
    'subscription-pending-message': 'El registro de tu cuenta de entrenador está pendiente de aprobación. Tendrás acceso limitado hasta que tu cuenta sea activada.',
    'subscription-pending-info': 'Estamos revisando tu solicitud y te notificaremos una vez aprobada. Esto normalmente toma 1-2 días hábiles.',
    'subscription-suspended-title': 'Cuenta Suspendida',
    'subscription-suspended-message': 'Tu cuenta ha sido suspendida. Por favor contacta a soporte para asistencia.',
    'subscription-cancelled-title': 'Suscripción Cancelada',
    'subscription-cancelled-message': 'Tu suscripción ha sido cancelada. Contacta a soporte para reactivar tu cuenta.',
    'subscription-unknown-title': 'Estado de Cuenta Desconocido',
    'subscription-unknown-message': 'No se puede determinar el estado de la cuenta. Por favor contacta a soporte.',
    'contact-support': 'Contactar Soporte',
    'limited-access-mode': 'Modo de Acceso Limitado',
    'limited-access-description': 'Tu cuenta está actualmente pendiente de aprobación. Una vez aprobada, tendrás acceso a todas las funciones de entrenador incluyendo:',
    'limited-access-features-1': 'Crear y gestionar atletas',
    'limited-access-features-2': 'Diseñar programas de entrenamiento personalizados',
    'limited-access-features-3': 'Hacer seguimiento del progreso y actividad de atletas',
    'limited-access-features-4': 'Enviar invitaciones a atletas',
    'limited-access-features-5': 'Análisis avanzados y reportes',
    'limited-access-review-time': 'Normalmente revisamos las solicitudes dentro de 1-2 días hábiles.',
    'access-restricted': 'Acceso Restringido',
    'access-restricted-suspended': 'Tu cuenta ha sido suspendida. Por favor contacta a soporte para resolver este problema.',
    'access-restricted-cancelled': 'Tu suscripción ha sido cancelada. Contacta a soporte para reactivar tu cuenta.',
    'access-restricted-default': 'El acceso a las funciones del panel está actualmente restringido. Por favor contacta a soporte para asistencia.'
  }
}; 